module.exports = __webpack_public_path__ + "static/media/mandil.d4e38325.jpg";